import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=3323e8fe&scoped=true&"
import script from "./advantages.vue?vue&type=script&lang=js&"
export * from "./advantages.vue?vue&type=script&lang=js&"
import style0 from "./advantages.vue?vue&type=style&index=0&id=3323e8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323e8fe",
  null
  
)

export default component.exports